// HOOKS
import { useMutation } from "@apollo/client";
// GRAPHQL
import { USER_PASSWORD_RESET_EMAIL } from "../../graphql/mutations/users/users.mutations";

const useSendPasswordReset = () => {
  const [sendPasswordResetEmail] = useMutation(USER_PASSWORD_RESET_EMAIL);

  const sendPasswordReset = async (email) => {
    try {
      const res = await sendPasswordResetEmail({ variables: { email } });
      if (res?.data?.userPasswordResetEmail)
        alert(res.data.userPasswordResetEmail);
    } catch (error) {
      console.error("useSendPasswordReset.sendPasswordReset", error);
    }
  };

  return { sendPasswordReset };
};

export default useSendPasswordReset;
